import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { ExtencionService } from 'src/app/services/extencion.service';

import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';

import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { ReporteService } from 'src/app/services/reporte.service';
const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-seleccion-fecha-reporte-excel',
  templateUrl: './seleccion-fecha-reporte-excel.component.html',
  styleUrl: './seleccion-fecha-reporte-excel.component.scss',
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }],
})
export class SeleccionFechaReporteExcelComponent implements OnInit {
  registerForm: UntypedFormGroup;

  constructor(
    public reporteSvc: ReporteService,
    private alertify: AlertifyService,
    private dialogRef: MatDialogRef<SeleccionFechaReporteExcelComponent>,
  ) {}

  ngOnInit(): void {
    this.inicarFormulario();
  }

  inicarFormulario() {
    this.registerForm = new UntypedFormGroup({
      fecha: new UntypedFormControl('', Validators.required),

    });
   
  }

  private getFormatoFecha(fecha: any): string {
    var d = new Date(fecha),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  generarReporte() {
  let fecha=this.registerForm.get('fecha')?.value.format('YYYY-MM-DD');
  console.log(fecha);
  //console.log( fecha.format('YYYY-MM-DD') );

    this.reporteSvc.getReporteIngresosPorFecha({fecha:fecha}).subscribe((result) => {
      console.log('result: ', result);
      let blob = new Blob([result], { type: 'application/vnd.ms-excel' });
      var downloadURL = window.URL.createObjectURL(result);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download =  'reporteIngresos' + '.xlsx';
      link.click();
      this.dialogRef.close(true);
    });
  }
}

